import { render, staticRenderFns } from "./resetMobile.vue?vue&type=template&id=fb78b658&scoped=true&"
import script from "./resetMobile.vue?vue&type=script&lang=js&"
export * from "./resetMobile.vue?vue&type=script&lang=js&"
import style0 from "./resetMobile.vue?vue&type=style&index=0&id=fb78b658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb78b658",
  null
  
)

export default component.exports